import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Lock body scroll on full-viewport play screen */
export function BodyRouteClass() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.toggle('route-play', pathname === '/play');
    return () => document.body.classList.remove('route-play');
  }, [pathname]);

  return null;
}
